import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'integrationPreview.title',
    defaultMessage: 'Integration',
    description: 'Title of the integration preview',
  },
  properties: {
    app: {
      id: 'properties.app',
      defaultMessage: 'App',
      description: 'Label of the property app',
    },
    name: {
      id: 'properties.name',
      defaultMessage: 'Name',
      description: 'Label of the property name',
    },
    isInstalled: {
      id: 'properties.isInstalled',
      defaultMessage: 'Installed',
      description: 'Label of the property is installed',
    },
    activeAt: {
      id: 'properties.activeAt',
      defaultMessage: 'Active at',
      description: 'Label of the property active at',
    },
    createdAt: {
      id: 'properties.createdAt',
      defaultMessage: 'Created at',
      description: 'Label of the property created at',
    },
  },
};

export default defineMessages(translations);
